import React, { Component } from 'react';
import { translate } from 'react-i18next';

class ProsaPaymentFailure extends Component {
  render() {
    const { t } = this.props;
    return(
      <div>
       <h2 className="page-header"> PAGO NO EXITOSO </h2>
       <div>
       {t('dashboard.invoice_payment.details')}
       </div>
      </div>
    );
  }
}

export default translate('common')(ProsaPaymentFailure);



// WEBPACK FOOTER //
// ./src/dashboard/invoices/payment/ProsaPaymentFailure.js